import { orchestrator } from 'satcheljs';
import {
    default as setPreferredEditorType,
    PreferredEditorTypeActionMessage,
} from '../actions/setPreferredEditorType';
import { setPreferredEditorTypeInStorage } from 'owa-mail-preferred-editor';

orchestrator(
    setPreferredEditorType,
    ({ viewState, composeEditorType }: PreferredEditorTypeActionMessage) => {
        setPreferredEditorTypeInStorage(viewState.bodyType, composeEditorType);
    }
);
